import { createUseStyles } from "react-jss";
import { SHOW_POWERBY } from "../../core";

const useStylesChatContainer = createUseStyles({
  container: {
    height: "100%",
    position: "relative",
    color: "#3A3F49",
    "& .rsc-input": {
      borderRadius: " 0 !important",
    },
    "& .rsc-ts-bubble ": {
      fontSize: "16px !important",
      textAlign: "right",
      overflow: "visible",
    },
    "& .rsc": {
      height: " 100% !important",
    },
    "& .rsc-container": {
      height: "100% !important",
    },
    "& .rsc-content": {
      paddingInline: 16,
      flex: 1,
      "& > div:last-child": {
        marginBottom: "32px!important",
      },
    },
  },
  "@media screen and (min-width: 687px) ": {
    container: {
      "& .rsc-input": {
        textAlign: "right",
        direction: "rtl",
      },
      "& .rsc-content": {
        "& > div:last-child": {
          marginBottom: "40px!important",
        },
      },
    },
  },
});
export default useStylesChatContainer;
